import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppSidebar } from './app-sidebar.component';
import { RouterModule } from '@angular/router';
import { AppSidebarMinimizerModule } from './app-sidebar-minimizer/app-sidebar-minimizer.module';
import { AppSidebarHeaderModule } from './app-sidebar-header/app-sidebar-header.module';
import { AppSidebarFormModule } from './app-sidebar-form/app-sidebar-form.module';
import { AppSidebarFooterModule } from './app-sidebar-footer/app-sidebar-footer.module';
import { NavDropdownDirectiveModule } from '../../directives/nav-dropdown/nav-dropdown.module';
@NgModule({
  declarations: [
    AppSidebar
  ],
  imports: [
    BrowserModule,
    RouterModule,
    NavDropdownDirectiveModule,
    AppSidebarMinimizerModule,
    AppSidebarHeaderModule,
    AppSidebarFormModule,
    AppSidebarFooterModule
  ],
  exports: [
    AppSidebar
  ]
})
export class AppSidebarModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/app-sidebar/app-sidebar.module.ts